import React from 'react';
import AvatarStyled from './Avatar.styled';

export interface AvatarProps {
  className?: string;
  src: string;
  name: string;
}

const Avatar = ({ className, src }: AvatarProps) => {
  return (
    <AvatarStyled className={className}>
      <img className="avatar-img" src={src} alt="" />
    </AvatarStyled>
  );
};
export default Avatar;
